import { Skeleton, Stack } from "@assetwatch/ui";
import { AssetsV2HighRiskAssetsTableSkeleton } from "./AssetsV2HighRiskAssetsTableSkeleton";

export function AssetsV2Loading() {
  return (
    <Stack>
      <Skeleton height={180} />
      <div className="grid grid-cols-1 gap-(--spacing-12) sm:grid-cols-3">
        <Skeleton height={124} />
        <Skeleton height={124} />
        <Skeleton height={124} />
      </div>
      <AssetsV2HighRiskAssetsTableSkeleton />
    </Stack>
  );
}
